export default __webpack_public_path__ + "KaTeX_SansSerif-Bold.5a20a4753af7a150824ce63096b7acc3.woff2";